import isObject from './isObject';
import isString from './isString';

export default function isKeyOf<T>(object: unknown, key: unknown): key is keyof T {
  return isObject(object) && isString(key) && Object.keys(object).includes(key);
}
